import { AmplitudeCategories, createTrackerForCategory } from "./amplitude";

export const trackEvent = createTrackerForCategory(AmplitudeCategories.SignupFlow);

export enum events {
    NavForward = "NavForward",
}

async function _getAuthController() {
    // @ts-ignore
    return await import("js/controllers/AuthController").then(module => module.default);
}

export async function NavForward({ step_name, step_number }: { step_name: string, step_number: number }) {
    const authController = await _getAuthController();
    const user = authController.currentUser;
    const eventProperties = {
        email: user?.email,
        userId: user?.uid,
        workspace_id: "all",
        step_name,
        step_number
    };
    trackEvent(events.NavForward, eventProperties, { audit: true });
}
